up.compiler(".up_toggle_prez", function (element) {
  const radioTrue = element.querySelector("#workshop_remote_status_true");
  const radioFalse = element.querySelector("#workshop_remote_status_false");

  const physicalAddress = document.querySelector("#js-physical-address");
  const onlineFields = document.querySelector("#js-online-fields");

  function theCallback() {
    if (radioTrue.checked) {
      physicalAddress.classList.remove("hidden");
      onlineFields.classList.add("hidden");
    } else {
      physicalAddress.classList.add("hidden");
      onlineFields.classList.remove("hidden");
    }
  }

  theCallback();

  radioTrue.addEventListener("click", theCallback);
  radioFalse.addEventListener("click", theCallback);
  return () => {
    radioTrue.removeEventListener("click", theCallback);
    radioFalse.removeEventListener("click", theCallback);
  };
});
